import { Button, Divider, Typography } from "@drone-js/core";
import { Fragment, useState } from "react";
import { useFieldArray, useFormContext } from "react-hook-form";
import type { PropertyData } from "../../../libs/codegen/property-onboarding";
import { VStack } from "../../commons/components/Stack.tsx";
import { useStaticDataAtomValue } from "../staticDataAtom.ts";
import { PhotosController } from "./PhotosController.tsx";

export const RoomPhotosController = () => {
    const [expand, setExpand] = useState(false);
    const { control } = useFormContext<PropertyData>();
    const { fields } = useFieldArray({
        control,
        name: "rooms",
    });
    const {
        cmsData: {
            photo: { addPhotos, roomPhotos, addPhotosNowOrLater, standardRoom, unitBedroomBathroom },
        },
    } = useStaticDataAtomValue();

    if (!expand)
        return (
            <Fragment>
                <VStack gap="8">
                    <Typography variant="heading-l" textColor="base.default">
                        {roomPhotos}
                    </Typography>
                    <Typography variant="body-s" textColor="base.subtle">
                        {addPhotosNowOrLater}
                    </Typography>
                </VStack>
                <Button
                    variant="label"
                    hierarchy="tertiary"
                    width="parent-fit"
                    size="m"
                    leadingIcon="fill.arrow.thin-dropdown"
                    label={addPhotos}
                    onClick={() => setExpand(true)}
                />
            </Fragment>
        );

    return fields.map((field, i) => (
        <VStack key={field.id} gap="24">
            <VStack gap="8">
                <Typography variant="heading-l" textColor="base.default">
                    {standardRoom}
                </Typography>
                <Typography variant="body-s" textColor="base.subtle">
                    {unitBedroomBathroom}
                </Typography>
            </VStack>
            <PhotosController fieldPrefix={`rooms.${i}`} roomPhotos />
            {i < fields.length - 1 && <Divider />}
        </VStack>
    ));
};
